import moment from 'moment'
import React, { MouseEvent, useEffect, useMemo, useState } from 'react'
import { IoCloseCircle as CloseIcon } from '@react-icons/all-files/io5/IoCloseCircle'
import { FaLock as LockedIcon } from '@react-icons/all-files/fa/FaLock'

import { NotesItemWrapper } from '../styledcomponents'
import Modal from '../../_Shared/Modal'
import useNotesContext from '../useNotesContext'
import { Error } from 'sharedb'
import DeleteNotes from '../modals/DeleteNotes'
import useToastify from '../../../helpers/useToastify'

const { GlobalState } = require('reflux')

interface NotesItemProps {
    id: string
    isActive: boolean
}

interface INotesData { 
    id: string
    title: string
    content: string
    created_by: string
    date_created: string
    date_updated: string
    updated_by: string
    isPrivate: boolean
}

function Items({
    id,
    isActive
}: NotesItemProps) {

    const { setActiveNote, activeNote, deleteNote, userId, connection, setInitialized, setInitializedTitle } = useNotesContext()
    const [ openDelete, setOpenDelete ] = useState<boolean>(false)
    const [notesData, setNotesData] = useState<INotesData>({
        id: '',
        title: '',
        content: '',
        created_by: '',
        date_created: '',
        date_updated: '',
        updated_by: '',
        isPrivate: false
    })

    const checkDate = (curDate: any) => {
        return curDate ? moment(curDate).calendar({
            sameDay: '[Today]',
        }) : ''
    }
    const similar = activeNote === id

    useEffect(() => {
        //@ts-ignore
        const note =  connection.get("sharednotessidebar", id);
        function unsubscribeNotesDoc() {
            note.unsubscribe((err: any) => {
                // console.error("note item unsubscribe error: ", {err})
            })
        }
        
        note.subscribe(update)
        note.on('op', update)
        function update(err: Error) {
            // if(err) //console.log("Error in notes item: ", {err, id})
            setNotesData({ ...(note?.data || {}) })
        }
        return () => {
            unsubscribeNotesDoc()
        }
    }, [id, userId])

    return useMemo(() => {
        const { 
            title,
            content,
            date_created: dateCreated,
            date_updated: dateUpdated,
            isPrivate
         } = notesData
        return <NotesItemWrapper className={isActive ? 'topbar' : ''} onClick={() => {
            if(!!!similar) {
                setActiveNote(id); 
                setInitialized(false); 
                setInitializedTitle(false);
            }
        }}>
        <Modal show={openDelete} overlayClicked={() => setOpenDelete(false)}>
            <DeleteNotes
                handleClose={() => setOpenDelete(false)}
                handleSubmit={(e: any) => { 
                    deleteNote({ id, e })
                    setOpenDelete(false)
                }}
            />
        </Modal>
        <div className="preview-header">
            <div className="preview-title">{title || 'New Note'}</div>
            <div className="preview-date">
                {
                    checkDate(dateUpdated || dateCreated) === 'Today' ?
                        moment(dateUpdated || dateCreated).fromNow() :
                        dateUpdated ?
                            moment(dateUpdated).format("MMMM DD, YYYY") :
                            moment(dateCreated).format("MMMM DD, YYYY")
                }
            </div>
        </div>
        <div className="preview-content">{content || 'No additional content'}</div>
        <CloseIcon className="close-icon" onClick={(e: MouseEvent<SVGElement>) => {
            if(e) {
                e.stopPropagation()
            }
            setOpenDelete(true)
        }} />
        {isPrivate ? <div className="private-flag"><LockedIcon size={9} /></div> : ''}
    </NotesItemWrapper>
    }, [id, notesData, isActive, openDelete, similar])
}

export default Items